import React, {useState, useEffect} from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import fetchData from '../../../function/fetchData';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';



const serverName = process.env.REACT_APP_SERVER_NAME;

// Druhy smluv
const listTypeOfContract = [  
    {id: 1 , type: 'contractProvize' , name :'Smlouva o zprostředkování' },
    {id: 2 , type: 'contractCodex' , name :'Codex' },
    {id: 3 , type: 'contractMain' , name :'Dohoda' },
    {id: 4 , type: 'contractualTransportation' , name :'Smluvní přeprava' },
]

const nameOfType = (type) => {
    const result = listTypeOfContract.filter( one => {
        return one.type === type
    })
    return result[0].name
}

console.log(nameOfType('contractCodex'))

const ListOfContract = ({server, token}) => {
    const [contractList, setContractList] = useState([])
    const [filterBy, setFilterBy] = useState(null)

    const getDataFromServer = async() => {
        fetchData(server + "api2/contractController.php" , {
            action: 'SHOW',
            token: token,
        }).then( (res) => {
 
            setContractList(res.payload)

        })
    }
 
    // POKUD nema token a má token of contract, stáhne si danou smlouvu
    useEffect( ()=> {
        if(token){
            getDataFromServer()
        }
    },[token])

    const handleDeleteOne = (id) => {
        if(token){
            fetchData(server + "api2/contractController.php" , {
                action: 'DELETE',
                token: token,
                id: id,
            }).then( (res) => {
                getDataFromServer()
            })
        }
    }

    const areYouSure = (id) => {
        const confirmDelete = window.confirm("Opravdu chcete smazat tuto položku?");
        if (confirmDelete) {
            handleDeleteOne(id)
        } 
    }

    return (
        <div style={{paddingLeft: 32, paddingRight: 32}}>
            <div style={{marginBottom: 16, display: 'flex', width: '100%'}}>
                <Dropdown size="sm" >
                    <Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
                        {!filterBy ? 'Filtr' : nameOfType(filterBy) }
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {
                            listTypeOfContract.map((one) => {
                                return  <Dropdown.Item key={one.id} href={"#/action-"  + one.id} onClick={()=> setFilterBy(one.type)}>
                                            {one.name}
                                        </Dropdown.Item>
                            })
                            
                        }
                        {filterBy &&
                            <Dropdown.Item href={"#/action-0"} onClick={()=> setFilterBy(null)}>
                                Zobrazit vše
                            </Dropdown.Item>
                        }
                       
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Row>
                <Col>
                    <strong>Datum</strong>
                </Col>
                <Col>
                    <strong>Typ dokumentu</strong>
                </Col>
                <Col>
                    <strong>Jméno</strong>
                </Col>
                <Col>
                    <strong>podepsáno</strong>
                </Col>
                <Col>

                </Col>
            </Row>
            {
                contractList.map( one => {
                    const list = one.form_data_json ? JSON.parse(one.form_data_json) : null
                    console.log(list)
                    if(!filterBy || (filterBy && one.type === filterBy)){
                        return (
                        
                                <Row key={one.id} style={{marginBottom: 16, borderBottom: '1px solid #eee', padding: 8}}>
                                    <Col >
                                        {list.date}
                                    </Col>
                                    <Col >
                                        <p>{nameOfType(one.type)}</p>
                                    </Col>
                                    <Col >
                                        {list.employee && list.employee}
                                        {list.objednatelFirma && list.objednatelFirma}
                                    </Col>
                                    <Col>
                                        {one.signature ? 'ano': 'ne'}
                                    </Col>
                                    <Col style={{display: 'flex', flexDirection: 'column', gap: 16, justifyContent: 'center', alignItems: 'flex-end'}} >
                                        <Dropdown size="sm" >
                                            <Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
                                                Možnosti
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="#/action-1">
                                                    <a href={serverName + "admin/smlouvy/" + one.token} target="_blank">Zobrazit</a> 
                                                </Dropdown.Item>
    
                                                <Dropdown.Item href="#/action-2">
                                                        <a href='#' style={{color: 'red'}} onClick={()=> areYouSure(one.id)}>smazat</a>
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                </Row>
                        
                        )

                    }
                })
            }
        </div>
    )
}

export default ListOfContract
